import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=39e371b8&scoped=true&"
import script from "./Search.vue?vue&type=script&lang=js&"
export * from "./Search.vue?vue&type=script&lang=js&"
import style0 from "./Search.vue?vue&type=style&index=0&id=39e371b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e371b8",
  null
  
)

/* custom blocks */
import block0 from "@/locales/site_search.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvar%2Fjenkins%2Fworkspace%2Fon-production-deploy%2Ffront%2Fcomponents%2FSearch%2FSearch.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports